import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

// Adapter minimalista con la misma “shape” que usamos de Ionic Storage:
// - create(): Promise<void>        -> no-op (compatibilidad)
// - get(key): Promise<any>
// - set(key, val): Promise<void>
// - remove(key): Promise<void>
// - clear(): Promise<void>         -> opcional
// - keys(): Promise<string[]>      -> opcional
// - driver: string                 -> para logs si lo usabas

@Injectable({ providedIn: 'root' })
export class PrefsStorageAdapter {
  public driver = 'capacitor-preferences';

  async create(): Promise<void> {
    // No hace falta inicialización con Preferences; mantener por compatibilidad
    return;
  }

  async get(key: string): Promise<any> {
    const { value } = await Preferences.get({ key });
    if (value == null) return null;
    // Si guardaste objetos, intenta parsear; si era string plano, devuélvelo tal cual
    try { return JSON.parse(value); } catch { return value; }
  }

  async set(key: string, val: any): Promise<void> {
    const value = typeof val === 'string' ? val : JSON.stringify(val);
    await Preferences.set({ key, value });
  }

  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }

  async clear(): Promise<void> {
    await Preferences.clear();
  }

  async keys(): Promise<string[]> {
    const { keys } = await Preferences.keys();
    return keys;
  }
}
